class FacetFiltersForm extends HTMLElement {
  constructor() {
    super()
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this)

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event)
    }, 500)

    const facetForm = this.querySelector("form")
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this))

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop")
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape)
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial
      if (searchParams === FacetFiltersForm.searchParamsPrev) return
      FacetFiltersForm.renderPage(searchParams, null, false)
    }
    window.addEventListener("popstate", onHistoryChange)
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable)
    })
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams
    const sections = FacetFiltersForm.getSections()
    const countContainer = document.getElementById("ProductCount")
    const countContainerDesktop = document.getElementById("ProductCountDesktop")
    document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading")
    if (countContainer) {
      countContainer.classList.add("loading")
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading")
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`
      const filterDataUrl = (element) => element.url === url

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event)
    })

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams)
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]
        FacetFiltersForm.renderFilters(html, event)
        FacetFiltersForm.renderProductGridContainer(html)
        FacetFiltersForm.renderProductCount(html)
      })
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html
    FacetFiltersForm.renderFilters(html, event)
    FacetFiltersForm.renderProductGridContainer(html)
    FacetFiltersForm.renderProductCount(html)
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML
    //Preview product card slider -- global js
    previewCardSlider()
    // chnage image card when hover color swatcher -- global.js
    chnageImageCardProdactPreview()
    //reload pagination
    ajaxPagination()
    //preview product
    clickPreviewProductPopup()
    //pricerang
    rangeCustom()
    //detail tag animation toggle
    detailsCustomSlideToggle()
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML
    const container = document.getElementById("ProductCount")
    const containerDesktop = document.getElementById("ProductCountDesktop")
    container.innerHTML = count
    container.classList.remove("loading")
    if (containerDesktop) {
      containerDesktop.innerHTML = count
      containerDesktop.classList.remove("loading")
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html")

    const facetDetailsElements = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter")
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false
    }
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element))
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex)

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML
    })

    FacetFiltersForm.renderActiveFacets(parsedHTML)
    FacetFiltersForm.renderAdditionalElements(parsedHTML)

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"))
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"]

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector)
      if (!activeFacetsElement) return
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML
    })

    FacetFiltersForm.toggleActiveFacets(false)
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"]

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML
    })

    document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected")
    const sourceElement = source.querySelector(".facets__selected")

    const targetElementAccessibility = target.querySelector(".facets__summary")
    const sourceElementAccessibility = source.querySelector(".facets__summary")

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML = source.querySelector(".facets__selected").outerHTML
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML = source.querySelector(".facets__summary").outerHTML
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`)
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form)
    return new URLSearchParams(formData).toString()
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event)
  }

  onSubmitHandler(event) {
    event.preventDefault()
    const sortFilterForms = document.querySelectorAll("facet-filters-form form")
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(event.target.closest("form"))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = []
      const isMobile = event.target.closest("form").id === "FacetFiltersFormMobile"

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") {
            forms.push(this.createSearchParams(form))
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form))
        }
      })
      this.onSubmitForm(forms.join("&"), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault()
    FacetFiltersForm.toggleActiveFacets()
    const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1)
    FacetFiltersForm.renderPage(url)
  }
}

FacetFiltersForm.filterData = []
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)
customElements.define("facet-filters-form", FacetFiltersForm)
FacetFiltersForm.setListeners()

class PriceRange extends HTMLElement {
  constructor() {
    super()
    this.querySelectorAll("input").forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)))
    this.setMinAndMaxValues()
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget)
    this.setMinAndMaxValues()
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input")
    const minInput = inputs[0]
    const maxInput = inputs[1]
    if (maxInput.value) minInput.setAttribute("max", maxInput.value)
    if (minInput.value) maxInput.setAttribute("min", minInput.value)
    if (minInput.value === "") maxInput.setAttribute("min", 0)
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"))
  }

  adjustToValidValues(input) {
    const value = Number(input.value)
    const min = Number(input.getAttribute("min"))
    const max = Number(input.getAttribute("max"))

    if (value < min) input.value = min
    if (value > max) input.value = max
  }
}

customElements.define("price-range", PriceRange)

class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const facetLink = this.querySelector("a")
    facetLink.setAttribute("role", "button")
    facetLink.addEventListener("click", this.closeFilter.bind(this))
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault()
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event)
    })
  }

  closeFilter(event) {
    event.preventDefault()
    const form = this.closest("facet-filters-form") || document.querySelector("facet-filters-form")
    form.onActiveFilterClick(event)
  }
}

customElements.define("facet-remove", FacetRemove)

//Custom Sorting position, chnage label name by click

//custom chnage checked filter input
document.querySelectorAll(".facets__list .sort-input").forEach((item) => {
  if (item.firstElementChild.checked === true) {
    item.parentNode.classList.add("checked")
    if (item.lastElementChild.textContent == "Date, new to old") {
      document.querySelector(".sorting-label-current").innerHTML = "Newest"
    } else {
      document.querySelector(".sorting-label-current").innerHTML = item.lastElementChild.textContent
    }
  }
  item.addEventListener("click", () => {
    item.parentNode.classList.add("checked")
    //siblings item li
    let siblingsItem = getSiblings(item.parentNode)
    siblingsItem.forEach((item) => {
      //siblings item li remove checked
      item.classList.remove("checked")
    })
    console.log(item.lastElementChild.textContent)

    if (item.lastElementChild.textContent == "Date, new to old") {
      document.querySelector(".sorting-label-current").innerHTML = "Newest"
    } else {
      document.querySelector(".sorting-label-current").innerHTML = item.lastElementChild.textContent
    }

    setTimeout(() => {
      document.querySelector(".facet-filters.facets-filters_sorting .facets__disclosure").removeAttribute("open")
    }, 500)
  })
})

//Custom Range price slider
function rangeCustom() {
  const rangeInput = document.querySelectorAll(".range-input"),
    priceInput = document.querySelectorAll(".price-input"),
    range = document.querySelector(".slider .progress")
  let priceGap = 2

  priceInput.forEach((input) => {
    input.addEventListener("input", (e) => {
      let minPrice = input.querySelectorAll("input")[0].value,
        maxPrice = input.querySelectorAll("input")[1].value

      if (maxPrice - minPrice >= priceGap && maxPrice <= input.parentNode.querySelectorAll(".range-input input")[1].max) {
        if (e.target.className === "input-min") {
          input.parentNode.querySelectorAll(".range-input input")[0].value = minPrice

          input.parentNode.querySelector(".slider .progress").style.left = (minPrice / input.parentNode.querySelectorAll(".range-input input")[0].max) * 100 + "%"
        } else {
          input.parentNode.querySelectorAll(".range-input input")[1].value = maxPrice

          input.parentNode.querySelector(".slider .progress").style.right = 100 - (maxPrice / input.parentNode.querySelectorAll(".range-input input")[1].max) * 100 + "%"
        }
      }
    })
  })

  rangeInput.forEach((input) => {
    let minVal = input.querySelectorAll("input")[0].value,
      maxVal = input.querySelectorAll("input")[1].value

    input.addEventListener("input", (e) => {
      minVal = input.querySelectorAll("input")[0].value
      maxVal = input.querySelectorAll("input")[1].value

      if (maxVal - minVal < priceGap) {
        if (e.target.className === "range-min") {
          input.querySelectorAll("input")[0].value = maxVal - priceGap
        } else {
          input.querySelectorAll("input")[1].value = minVal + priceGap
        }
      } else {
        input.parentNode.querySelectorAll(".price-input input")[0].value = minVal
        input.parentNode.querySelectorAll(".price-input input")[1].value = maxVal

        input.parentNode.querySelector(".slider .progress").style.left = (minVal / input.querySelectorAll("input")[0].max) * 100 + "%"
        input.parentNode.querySelector(".slider .progress").style.right = 100 - (maxVal / input.querySelectorAll("input")[1].max) * 100 + "%"
      }
    })

    input.parentNode.querySelector(".slider .progress").style.left = (minVal / input.querySelectorAll("input")[0].max) * 100 + "%"
    input.parentNode.querySelector(".slider .progress").style.right = 100 - (maxVal / input.querySelectorAll("input")[1].max) * 100 + "%"
  })
}
rangeCustom()
